import { gql } from '@apollo/client';

const PROFILE_FRAGMENT = gql`
  fragment ProfileDetails on Profile {
    id
    gender
    birthDate
    identifier
    address {
      line1
      line2
      administrativeAreaLevel1
      administrativeAreaLevel2
      administrativeAreaLevel3
    }
    partner {
      firstName
      birthDate
      gender
    }
    educationLevel {
      code
    }
    children {
      firstName
      birthDate
    }
    numberOfHomeComponents
    pets {
      type
    }
    policies {
      code
      name
    }
    lifestyles {
      code
    }
    interests {
      code
    }
    allergies {
      code
    }
    diet {
      code
    }
    preference {
      alcohol
      bio
      light
      noGluten
    }
    notAnswered
    phoneNumber
  }
`;

export default PROFILE_FRAGMENT;
